import { FileUp } from "lucide-react";
import type { ReactNode } from "react";

import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";
import { pluralize } from "@src/shared/utils/strings";

export function UploadHistoryTable({
  children,
  label,
}: {
  children: ReactNode;
  label: string;
}) {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-[12px] border border-border bg-background">
      <div className="grid shrink-0 grid-cols-[minmax(150px,1.15fr)_minmax(160px,1.1fr)_120px_80px_72px] gap-3 border-b border-border bg-muted/45 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.08em] text-muted-foreground">
        <span>Patient</span>
        <span>File</span>
        <span>Uploaded</span>
        <span>Gaps</span>
        <span className="text-right">Action</span>
      </div>
      <ul
        aria-label={label}
        className="min-h-0 flex-1 divide-y divide-border overflow-y-auto"
      >
        {children}
      </ul>
    </div>
  );
}

export function UploadHistoryProcessingRow({ count }: { count: number }) {
  if (count === 0) return null;

  return (
    <li>
      <div className="grid grid-cols-[minmax(150px,1.15fr)_minmax(160px,1.1fr)_120px_80px_72px] items-center gap-3 bg-muted/20 px-3 py-2.5">
        <HorizontalFlexbox alignItems="center" className="min-w-0 gap-2">
          <div className="flex size-[28px] shrink-0 items-center justify-center rounded-[8px] bg-primary/10 text-primary">
            <FileUp className="size-[14px]" aria-hidden="true" />
          </div>
          <VerticalFlexbox className="min-w-0">
            <span className="truncate text-[13px] font-semibold text-surface-foreground">
              Reading {count} {count === 1 ? "file" : "files"} and extracting
              care gaps
            </span>
            <span className="font-mono text-[10px] text-muted-foreground">
              {pluralize(count, "job")} in progress
            </span>
          </VerticalFlexbox>
        </HorizontalFlexbox>
        <span className="font-mono text-[10.5px] text-muted-foreground">
          Extracting files
        </span>
        <span className="font-mono text-[10.5px] text-muted-foreground">
          Now
        </span>
        <span className="font-mono text-[10.5px] text-muted-foreground">-</span>
        <span className="text-right font-mono text-[10.5px] text-muted-foreground">
          Pending
        </span>
      </div>
    </li>
  );
}
